import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-add-edit-form-skeleton',
  templateUrl: './add-edit-form-skeleton.component.html',
  styleUrls: ['./add-edit-form-skeleton.component.scss']
})
export class AddEditFormSkeletonComponent implements OnChanges {
  @Input() tabCount = 1;
  @Input() sectionCount = 1;
  @Input() fieldsPerSection = 20;
  @Input() fieldColsClass = 'col-12 sm:col-6 lg:col-3';

  tabs: number[] = [];
  sections: number[] = [];
  fields: number[] = [];

  constructor() {
    this.rebuildArrays();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabCount'] || changes['sectionCount'] || changes['fieldsPerSection']) {
      this.rebuildArrays();
    }
  }

  private rebuildArrays(): void {
    this.tabs = new Array(Math.max(0, this.tabCount || 0));
    this.sections = new Array(Math.max(1, this.sectionCount || 1));
    this.fields = new Array(Math.max(1, this.fieldsPerSection || 20));
  }
}
